import {
	AUTHENTICATION_INITIAL_STATE, AUTHENTICATION_SUCCESS, AUTHENTICATION_PENDING, 
	AUTHENTICATION_ERROR, REGISTRATION_ERROR, REGISTRATION_SUCCESS, DEFAULT_ROLE} from './ActionTypes';
import api from '../api'
import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';
export function loginInitial() {
	return function (dispatch) {
		dispatch({
			type: AUTHENTICATION_INITIAL_STATE
		});
	}
}

const delay = ms => new Promise(res => setTimeout(res, ms));

export function registrationAction(router, data) {
	return function (dispatch) {
	//  console.log("======="+JSON.stringify(data));
	router.setState({
		activityIndicatorProcess: true,
		displayCloseButton:false
	});
	
	let formData = new FormData();
	if(data.library_image !== null){
		formData.append('library_image', data.library_image);
	}

	if(data.user_image !== null){
		formData.append('user_image', data.user_image);
	}


	formData.append('library_name', data.library_name);
	// formData.append('address_line1', data.address_line1);
	// formData.append('address_line2', data.address_line2);
	// formData.append('city', data.city);
	// formData.append('state', data.state);
	// formData.append('country', data.country);
	// formData.append('zipcode', data.zipcode);
	formData.append('interested_in_stem', data.interested_in_stem);
	formData.append('state_or_county', data.state_or_county);
	formData.append('website_url', data.website_url);
	// formData.append('notes', data.notes);
	formData.append('library_email', data.library_email);
	formData.append('library_phone', data.library_phone);

	formData.append('user_type', data.user_type);
	formData.append('first_name', data.first_name);
	formData.append('last_name', data.last_name);
	formData.append('email', data.email);
	formData.append('password', data.password);

	api.normalPost("libraries/registration", formData).then(async (response) => {
		// console.log("======="+JSON.stringify(response))
		if (response.status === "success") {
			await delay(3000);
			router.setState({
				activityIndicatorProcess: false,
				displayCloseButton:true,
				registerError: response.message,
				statuses: response.status
			}); 
			await dispatch({
				type: REGISTRATION_SUCCESS,
				data: response.message
			});
		}else {
			await delay(3000);
			router.setState({
					activityIndicatorProcess: false,
					displayCloseButton:true,
					registerError: response.message,
					statuses: response.status
			});
			await dispatch({
				type: REGISTRATION_ERROR,
				data: response.message
			});
		}
		// if (response.status === "success") {
		// 	// alert(JSON.stringify(response.payload))
		// 	toast.success(MESSAGE.library_create, {
		// 		position: toast.POSITION.BOTTOM_RIGHT
		// 	});
		// 	await dispatch({
		// 		type: REGISTRATION_SUCCESS,
		// 		data: response.payload
		// 	});
		// } else {
		// 	toast.error(response.message, {
		// 		position: toast.POSITION.BOTTOM_RIGHT
		// 	});
		// 	await dispatch({
		// 		type: REGISTRATION_ERROR,
		// 		data: response.message
		// 	});
		// }
	})
	router.setState({
        open: false,
     }); 
	}
}

export function teamRegistration(router, data) {
	return function (dispatch) {
		//  console.log("======="+JSON.stringify(data));
		router.setState({
			activityIndicatorProcess: true,
			displayCloseButton:false
		}); 

		let formData = new FormData();
		if(data.team_image !== null){
			formData.append('team_image', data.team_image);
		}

		if(data.coach_image !== null){
			formData.append('coach_image', data.coach_image);
		}

		formData.append('team_name', data.team_name);
		formData.append('city', data.city);
		formData.append('interested_in_stem', data.interested_in_stem === true ? true : false);
		formData.append('website_url', data.website_url);
		formData.append('description', data.description);

		formData.append('user_type', data.user_type);
		formData.append('first_name', data.first_name);
		formData.append('last_name', data.last_name);
		formData.append('email', data.email);
		formData.append('password', data.password);

		api.normalPost("teams/registration", formData).then(async (response) => {
			if (response.status === "success") {
				await delay(3000);
				router.setState({
					activityIndicatorProcess: false,
					displayCloseButton:true,
					registerError: response.message,
					statuses: response.status
				}); 
				await dispatch({
					type: REGISTRATION_SUCCESS,
					data: response.message
				});
			}else {
				await delay(3000);
				router.setState({
					activityIndicatorProcess: false,
					displayCloseButton:true,
					registerError: response.message,
					statuses: response.status
				});
				await dispatch({
					type: REGISTRATION_ERROR,
					data: response.message
				}); 
			}
		})
		router.setState({
			open: false,
		}); 
	}
}

export function loginAction(router, data, launchHeaderThis) {
	return function (dispatch) {
		dispatch({
			type: AUTHENTICATION_PENDING
        });
        console.log(JSON.stringify(data))
		api.post('login', data).then((response) => {
			if (response.status === "success") {
				if (response.payload.status === "ACTIVE") {
				localStorage.setItem('token', JSON.stringify(response.token));
				launchHeaderThis.setState({
					modelState: false,
				 }); 
				 dispatch({
					type: AUTHENTICATION_SUCCESS,
					data: response.payload
				});
				let defaultRole = response.payload.user_type;
				dispatch({
					type: DEFAULT_ROLE,
					data: defaultRole
				});
				if(defaultRole==="THUNDERBOT"){
					router.context.router.history.push('/users');
				}else if(defaultRole==="LIBRARIAN"){
					router.context.router.history.push('/libraries');
				}else{
					router.context.router.history.push('/teams',{selectedTab:0});
				}
				
			}else{
				router.setState({
					loginErrorMsg: "Please wait your approval in progress"
				});
				dispatch({
					type: AUTHENTICATION_ERROR,
					data: "Please wait your approval in progress"
				});
			}
		}else{
			router.setState({
				loginErrorMsg: response.message
			});
			dispatch({
				type: AUTHENTICATION_ERROR,
				data: response.message
			});
		}
		});
	}
}


export function authenticate() {
	return (dispatch) => {
		dispatch({
			type: AUTHENTICATION_PENDING
		});
		return api.get('authenticate')
			.then((response) => {
				console.log(JSON.stringify(response))
				if (response.status === "success") {
					if (response.payload.status === "ACTIVE") {
					localStorage.setItem('token', JSON.stringify(response.token));
					 dispatch({
						type: AUTHENTICATION_SUCCESS,
						data: response.payload
					});
					let defaultRole = response.payload.user_type;
					dispatch({
						type: DEFAULT_ROLE,
						data: defaultRole
					});
				}else{
					dispatch({
						type: AUTHENTICATION_ERROR,
						data: "Please wait your approval in progress"
					});
				}
			}else{
				dispatch({
					type: AUTHENTICATION_ERROR,
					data: response.message
				});
			}
			})
			.catch((e) => {
				dispatch({
					type: AUTHENTICATION_ERROR,
				});
				localStorage.removeItem('token');
				window.location = '/';
			});
	};
}

export const unauthenticate = () => ({
	type: AUTHENTICATION_ERROR
});

export const forgotPasswordAction =(router, data, launchHeaderThis) => {
	return function (dispatch) {
		api.post('forgot-password', data).then(async (response) => {
			if (response.status === "success") {
				router.setState({
					status: response.status,
					loginErrorMsg: response.message 
				})
			} else {
				router.setState({
					status: response.status,
					loginErrorMsg: response.message
				});
			}
		})
	}
}
export const changePasswordAction =(router, data) => {
	return function (dispatch) {
		api.post('verify', data).then(async (response) => {
			if (response.status === "success") {
				toast.success(MESSAGE.password_changed, {
					position: toast.POSITION.BOTTOM_RIGHT
				});
				router.props.history.push('/')
			}
		})
	}
}